import {LeadStatusNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";

/**
 * Lead status notification class data.
 */
export default class LeadStatusNotificationData {
	/**
	 * @param {string} leadId Lead Id which status was changed.
	 * @param {string} creator Entity who changed Lead status.
	 * @param {string} previousStatusId Previous Lead status id.
	 * @param {string} currentStatusId Current Lead status id.
	 * @param {string} referenceNumber Lead reference number.
	 */
	constructor(readonly leadId: string,
		readonly creator: AuthenticatedEntity,
		readonly currentStatusId: string,
		readonly previousStatusId: string,
	readonly  referenceNumber: string){}

	static fromJson(json: LeadStatusNotificationDataApiDto): LeadStatusNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new LeadStatusNotificationData(
			json.leadId,
			creator,
			json.currentStatus,
			json.previousStatus,
			json.referenceNumber);
	}
}
